import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export type Lang = 'es' | 'gb' | 'de' | 'fr' | 'nl' | 'it';

type LangState = {
  lang: Lang;
  setLang: (lang: Lang) => void;
};

export const useLang = create<LangState>()(
  persist(
    (set) => ({
      lang: 'es',
      setLang: (lang) => set({ lang }),
    }),
    { name: 'espectaculos-lang' }
  )
);
